// Index

var $brandSlider = $(".js-brand-slider");
let brandSliderPlay = false;

if ($(window).width() > 992) { 
  $brandSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    speed: 250,
    infinite: true,
    fade: true,
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false
  });
  brandSliderPlay = true;
}

var $mdMax = $('.item-md-max');
var $mdXxl = $('.item-md-xxl');

// hero block logo animation
$(window).on('scroll resize', function() {
  if ( $(window).width() > 1440) { 
    $mdXxl.remove()
  } else if ( $(window).width() > 992) { 
    $mdMax.remove()
  } else { 
    $mdXxl.remove()
  };
});

if ( $(window).width() > 992) { 
  $mdMax.remove();
};

if ( $(window).width() < 992) { 
  $mdXxl.remove();
};

if ( $(window).width() > 1440) { 
  $mdXxl.remove();
};

jQuery(document).ready(function($) {

  var times = 3000;
  if ( $(window).width() < 992) { 
    var times = 1500;
  };

  $(window).on('scroll resize', function() {
    if ( $(window).width() < 992) { 
      setInterval(function() {
        moveBottom1();
        moveBottom2();
        moveBottom3();
        moveBottom4();
      }, 1500);
    }
  });

  setInterval(function(times) {
    moveBottom1();
    moveBottom2();
    moveBottom3();
    moveBottom4();
  }, times);



  var slideCount = $('.customers-logos__item').length;
  var slideHeight = $('.customers-logos__item').height();
  var sliderUlHeight = slideCount * slideHeight;

  $('.customers-logos__slider').css({
    height: slideHeight
  });

  $('.customers-logos__cont').css({
    height: sliderUlHeight,
    marginTop: -slideHeight
  });

  $('.customers-logos__item').css({
      opacity: 1
  });

  $('#slider1 .customers-logos__item:last-child').prependTo('#slider1');
  $('#slider2 .customers-logos__item:last-child').prependTo('#slider2');
  $('#slider3 .customers-logos__item:last-child').prependTo('#slider3');
  $('#slider4 .customers-logos__item:last-child').prependTo('#slider4');

  function moveBottom1() {
    $('#slider1').delay(500).animate({
      bottom: +slideHeight
    }, 400, function() {
      $('#slider1 .customers-logos__item:first-child').appendTo('#slider1');
      $('#slider1').css('bottom', '');
    });
  };

  function moveBottom2() {
    $('#slider2').delay(550).animate({
      bottom: +slideHeight
    }, 400, function() {
      $('#slider2 .customers-logos__item:first-child').appendTo('#slider2');
      $('#slider2').css('bottom', '');
    });
  };

  function moveBottom3() {
    $('#slider3').delay(600).animate({
      bottom: +slideHeight
    }, 400, function() {
      $('#slider3 .customers-logos__item:first-child').appendTo('#slider3');
      $('#slider3').css('bottom', '');
    });
  };

  function moveBottom4() {
    $('#slider4').delay(650).animate({
      bottom: +slideHeight
    }, 400, function() {
      $('#slider4 .customers-logos__item:first-child').appendTo('#slider4');
      $('#slider4').css('bottom', '');
    });
  };
});



$(".js-themes-preview").slick({
  slidesToShow: 1,
  mobileFirst: true,
  autoplay: false,
  dots: false,
  infinite: true,
  prevArrow: $("[data-themes-preview-prev]"),
  nextArrow: $("[data-themes-preview-next]"),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

$(".js-extensions-preview").slick({
  slidesToShow: 1,
  mobileFirst: true,
  autoplay: false,
  dots: false,
  infinite: true,
  prevArrow: $("[data-extensions-preview-prev]"),
  nextArrow: $("[data-extensions-preview-next]"),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

$(".js-gallery-customization").slick({
  slidesToShow: 1,
  dots: true,
  mobileFirst: true,
  speed: 500,
  prevArrow: $("[data-customization-prev]"),
  nextArrow: $("[data-customization-next]"),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});

$(".js-gallery").magnificPopup(ZDT.galleryOptions);

$('.themes-popup').magnificPopup({
  centerMode: true,
  type: "image",
  closeOnContentClick: false,
  closeBtnInside: false,
  mainClass: "mfp-with-zoom mfp-img-mobile",
  image: {
    verticalFit: true
  },
  gallery: {
    enabled: true
  }
});

var $navbar = $("[data-navbar]");

$("#navbar-collapse").on("show.bs.collapse", function() {
  $navbar.removeClass("navbar-inverse").addClass("navbar-default");
  $navbar.addClass("navbar--opened");
});


$("#navbar-collapse").on("hide.bs.collapse", function() {
  if ($(window).scrollTop() < $(".case-banner").outerHeight()) {
    $navbar.removeClass("navbar-default").addClass("navbar-inverse");
  }
  $navbar.removeClass("navbar--opened");
});

$(window).on("scroll resize", function() {
  if ($(window).scrollTop() > $(".case-banner").outerHeight()) {
    $navbar.removeClass("navbar-inverse").addClass("navbar-default");
  } else {
    $navbar.removeClass("navbar-default").addClass("navbar-inverse");
  }
});

$(window).trigger("resize"); // navbar

$(window).resize(function() {
  if ( $(window).width() < 768 ) {
    var touch = $('#touch-nav');
    var menu = $('.nav');
    $(touch).on('click', function(e) {

      e.preventDefault();

      menu.slideToggle();

    });
  }
});

if ( $(window).width() > 992 ) {
  var rellax = new Rellax('.rellax', {
    speed: 7,
    center: true,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false
  });

  var rellax = new Rellax('.rellax', {
    wrapper: '.custom-element'
  });
}

//brand-logos mobile
var $logosBtn = $('[data-logos-btn]');
var $logosShadow = $('[data-logos-shadow]');
  $logosBtn.click(function() {
    $(this).hide();
    $logosShadow.remove();
    $('.brand-logos__items--first .brand-logos__item').addClass('brand-logos__active');
    $('.show-logo').slideDown(10).addClass('brand-logos__active');
    return false;
});

//brand-logos desktop fade slider
$(window).on('scroll resize', function() {
  if ( $(window).width() > 992) {
    if (!$brandSlider.hasClass('slick-slider')) {
      $brandSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 250,
        slickPause: true,
        infinite: true,
        fade: true,
        autoplay: true,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false
      });
      brandSliderPlay = true;
    } else {
      if ($brandSlider.visible() && !brandSliderPlay) {
        $brandSlider.slick("slickPlay");
        brandSliderPlay = true;
      } else if (!$brandSlider.visible() && brandSliderPlay) {
        $brandSlider.slick("slickPause");
        brandSliderPlay = false;
      }
    }
  } else {
    if ($brandSlider.hasClass('slick-slider')) {
      $brandSlider.slick('unslick');
      brandSliderPlay = false;
    }
  };
});